module.exports = __webpack_public_path__ + "static/contact-22aa0712a6569977c3d6af76e51758a7.svg";